import React, { useState } from "react";
import classes from "./DistributeFooter.module.scss";
import Button from "../../../components/Common/Button/Button";
import { useNavigate } from "react-router";
import { distributeTo } from "../../../utils/mainTabs/distribute/distributeTo";
import { useSelector, useDispatch } from "react-redux";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import CreateCollectionModal from "../CreateCollection/CreateCollectionModal/CreateCollectionModal";
import { createSeries } from "../../../utils/mainTabs/distribute/createSeries";
import { FormattedMessage } from "react-intl";

const DistributeFooter = ({ tenantName }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const distributeState = useSelector((state) => state.distributeReducer);
  const { selctedShotclassData, selctedSeriesData, selctedCollectionData } =
    distributeState;
  const [isCreateCollectionModal, setIsCreateCollectionModal] = useState(false);

  const distributeClick = () => {
    if (selctedShotclassData?.length > 0 || selctedSeriesData?.length > 0)
      navigate(distributeTo.path(tenantName));
    else
      dispatch(
        setErrorHandler(
          errorTypes?.WARN,
          "At least select one Shotclass/series to proceed....."
        )
      );
  };

  const createCollectionClick = () => {
    if (selctedShotclassData?.length > 0)
      setIsCreateCollectionModal(!isCreateCollectionModal);
    else
      dispatch(
        setErrorHandler(
          errorTypes?.WARN,
          "At least select one Shotclass to proceed......"
        )
      );
  };

  const createSeriesClick = () => {
    if (selctedShotclassData?.length > 0 || selctedCollectionData?.length > 0)
      navigate(createSeries.path(tenantName));
    else
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "At least select one Shotclass to proceed......"
        )
      );
  };

  return (
    <>
      <div className={classes.distribute_footer}>
        <Button
          type="save"
          label={<FormattedMessage id="P_DISTRIBUTE" />}
          // small
          dark
          onClick={distributeClick}
          height="4"
          width="13"
          disabled={
            selctedShotclassData?.length > 0 ||
            selctedSeriesData?.length > 0 ||
            selctedCollectionData?.length > 0
              ? false
              : true
          }
        />
        {/* <Button
          type="save"
          label="Create Series"
          // small
          dark
          onClick={createSeriesClick}
          height="4"
          width="13"
          disabled={
            selctedShotclassData?.length > 0 ||
            selctedSeriesData?.length > 0 ||
            selctedCollectionData?.length > 0
              ? false
              : true
          }
        /> */}
        {/* <Button
          type="save"
          label="Create Collection"
          // small
          dark
          onClick={createCollectionClick}
          height="4"
          width="15"
        /> */}
      </div>
      <CreateCollectionModal
        setIsCreateCollectionModal={setIsCreateCollectionModal}
        isCreateCollectionModal={isCreateCollectionModal}
      />
    </>
  );
};

export default DistributeFooter;
